module.exports = __webpack_public_path__ + "static/img/跨系统数据核验.9f7bd6cf.png";